// extracted by mini-css-extract-plugin
export default {"right":"spinner_right__8220Y","big":"spinner_big__VIKwo","spin":"spinner_spin__zo8Zl","small":"spinner_small__J5MFe"};